// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fwlZ","index":"styles_index__eMm1M"};